import { type Destination } from './derive';
import { palette } from './palette';

export function TopDestinationsList({
  destinations,
  rangeLabel,
}: {
  destinations: Destination[];
  rangeLabel?: string;
}) {
  if (destinations.length === 0) return null;
  const max = Math.max(...destinations.map((d) => d.count));
  return (
    <div
      className="rounded-xl border border-border px-[18px] py-4"
      style={{ borderColor: palette.hair }}
    >
      <div className="mb-2.5 flex items-baseline justify-between">
        <div className="text-[10px] font-bold tracking-[0.14em] text-muted">
          TOP DESTINATIONS
        </div>
        <div className="font-mono text-[10px]" style={{ color: palette.faint }}>
          dispatches{rangeLabel ? ` · ${rangeLabel}` : ''}
        </div>
      </div>
      <div className="flex flex-col gap-2">
        {destinations.map((d) => (
          <div
            key={d.name}
            className="grid items-center gap-3 text-[13px]"
            style={{ gridTemplateColumns: '160px 1fr 32px' }}
          >
            <span className="font-semibold">{d.name}</span>
            <div
              className="relative h-2.5 rounded-sm"
              style={{ background: palette.bgAlt }}
            >
              <div
                className="h-full rounded-sm"
                style={{ width: `${(d.count / max) * 100}%`, background: palette.good }}
              />
            </div>
            <span className="text-right font-mono font-bold tabular-nums">{d.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
